// import {BrowserRouter as Router} from 'react-router-dom';
// import RootRoute from './routes/RootRoute';
// import {AuthProvider} from './providers/AuthProvider';
// import {SenhaProvider} from './providers/SenhaProvider';
import {QueryClient} from '@tanstack/react-query';
// import {ReactQueryDevtools} from '@tanstack/react-query-devtools';
// import {GoogleReCaptchaProvider} from 'react-google-recaptcha-v3';
import 'react-toastify/dist/ReactToastify.css';
import './App.css'
import React, {lazy} from "react";
import AppLogo from "./components/AppLogo/AppLogo";

const GoogleReCaptchaProvider = lazy(() => import('react-google-recaptcha-v3').then((module) => {
    return {default: module.GoogleReCaptchaProvider}
}));

const RootRoute = lazy(() => import('./routes/RootRoute'));

const AuthProvider = lazy(() => import('./providers/AuthProvider').then((module) => {
    return {default: module.AuthProvider}
}));

const Router = lazy(() => import('react-router-dom').then((module) => {
    return {default: module.BrowserRouter}
}));

const SenhaProvider = lazy(() => import('./providers/SenhaProvider').then((module) => {
    return {default: module.SenhaProvider}
}));

const QueryClientProvider = lazy(() => import('@tanstack/react-query').then((module) => {
    return {default: module.QueryClientProvider}
}));

const ReactQueryDevtools = lazy(() => import('@tanstack/react-query-devtools').then((module) => {
    return {default: module.ReactQueryDevtools}
}));

const queryClient = new QueryClient()

function App() {
    return (
        <div data-testid={'App'} className={'App'}>

            <div className="container">
                <AppLogo inverted={true}/>
                <br/>

                <br/>
                <h1>Comunicado Importante</h1>
                <p>Informamos que as vendas da Digital Sim foram encerradas.</p>
                <p>Caso você tenha algum contrato em andamento ou precise de suporte, pedimos que entre em contato com a
                    nossa equipe através do e-mail: <a
                        href={'mailto:atendimento@dinheirosim.com.br'}
                        className={'email'}
                    >atendimento@dinheirosim.com.br</a>.</p>
                <p>Agradecemos a todos os nossos clientes pela confiança durante esse período.</p>
                <div className="footer">
                    Atenciosamente,<br/>
                    Equipe Digital Sim
                </div>
            </div>
        </div>
    );
}

export default App;
